
import {
  computed, defineComponent, reactive,
  ref,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import ServicoApp from '@/servicos/ServicoApp';
import { IInspecao, IInspecaoAcesso } from '@/models/Entidades/IInspecao';
import ComboSegurado from './ComboSegurado.vue';
import ComboUsuario from './ComboUsuario.vue';
import ComboCidade from './ComboCidade.vue';
import CadastroSeguradoModal from '@/components/CadastroSeguradoModal.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';
import ServicoUtilitario from '@/servicos/ServicoUtilitario';
import CampoCep from '@/core/components/UI/CampoCep.vue';
import ServicoCadastro from '@/servicos/ServicoCadastro';
import storeApp from '@/store/storeApp';

export default defineComponent({
  name: 'InspecaoDadosPrincipais',
  props: {
    inspecao: {
      type: Object as () =>IInspecao,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
    acessoExterno: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Card,
    ComboSegurado,
    ComboUsuario,
    ComboCidade,
    CadastroSeguradoModal,
    SelecionarData,
    CampoCep,
  },
  emits: ['update:inspecao', 'change', 'consultarCnpj'],
  setup(props, { emit }) {
    const servicoApp = new ServicoApp();
    const servicoCadastro = new ServicoCadastro();
    const servicoUtilitario = new ServicoUtilitario();
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      apresentarCadastroSegurado: false,
      cep: '',
    });
    const consultandoCep = ref<boolean>(false);

    const computedInspecao = computed({
      get: () => props.inspecao,
      set: (valor: IInspecao) => {
        emit('update:inspecao', valor);
      },
    });

    function obtemCodigoCadastro(): number {
      if (UtilitarioGeral.validaCodigo(computedInspecao.value.codigoCadastro)) {
        return computedInspecao.value.codigoCadastro;
      }

      return 0;
    }

    function consultarCnpj() {
      emit('consultarCnpj');
    }

    function change() {
      emit('change');
    }

    async function cadastroAtualizado(codigo:number) {
      computedInspecao.value.codigoCadastro = codigo;
      const segurado = await servicoCadastro.obter(codigo);
      if (UtilitarioGeral.objetoValido(segurado)) {
        if (!UtilitarioGeral.valorValido(computedInspecao.value.cep)) {
          computedInspecao.value.cep = segurado.endereco.cep;
          computedInspecao.value.localizacaoGpsCheckin = segurado.endereco.localizacao;
          computedInspecao.value.enderecoCompleto = segurado.endereco.enderecoCompleto;
          computedInspecao.value.complemento = segurado.endereco.complemento;
          computedInspecao.value.bairro = segurado.endereco.bairro;
          computedInspecao.value.codigoCidade = segurado.endereco.codigoCidade;
        }
      }
    }

    async function consultaCep() {
      if (UtilitarioGeral.valorValido(computedInspecao.value.cep) && UtilitarioGeral.validaValorComLimiteCaracteres(computedInspecao.value.cep, 8)) {
        if (computedInspecao.value.cep !== state.cep) {
          consultandoCep.value = true;
          const retornoConsultaCep = await servicoUtilitario.consultaCep(computedInspecao.value.cep);
          if (retornoConsultaCep !== undefined) {
            computedInspecao.value.enderecoCompleto = retornoConsultaCep.logradouro;
            computedInspecao.value.complemento = retornoConsultaCep.complemento;
            computedInspecao.value.bairro = retornoConsultaCep.bairro;
            computedInspecao.value.codigoCidade = retornoConsultaCep.codigoCidade;
            state.cep = computedInspecao.value.cep;
          }
        }
      }

      consultandoCep.value = false;
    }

    function apresentarCadastro() {
      console.log('clicou');
      state.apresentarCadastroSegurado = true;
    }

    function adicionarAcesso() {
      if (!computedInspecao.value.acessos) {
        computedInspecao.value.acessos = [];
      }

      const acesso:IInspecaoAcesso = {} as IInspecaoAcesso;
      acesso.codigo = 0;
      acesso.codigoInspecao = computedInspecao.value.codigo || 0;
      acesso.chave = '0000';

      computedInspecao.value.acessos.push(acesso);
    }

    function removerAcesso(index:number) {
      computedInspecao.value.acessos.splice(index, 1);
    }

    function copiarLinkAcesso(acesso:IInspecaoAcesso) {
      if (acesso.codigo > 0 && UtilitarioGeral.valorValido(acesso.chave)) {
        navigator.clipboard.writeText(`https://app.ropeseguros.com.br/inspecoes/key/${acesso.chave}`);
      }
    }

    return {
      props,
      computedInspecao,
      state,
      change,
      consultarCnpj,
      obtemCodigoCadastro,
      cadastroAtualizado,
      consultaCep,
      consultandoCep,
      apresentarCadastro,
      adicionarAcesso,
      removerAcesso,
      copiarLinkAcesso,
      storeApp,
    };
  },
});
